import type { QueryClient } from '@tanstack/react-query';

let queryClientRef: QueryClient | null = null;

export function setQueryClientSingleton(client: QueryClient): void {
  queryClientRef = client;
}

export function getQueryClientSingleton(): QueryClient | null {
  return queryClientRef;
}
